import { GiftQuantityInput, GiftSelector } from '../../../../../../Gift'
import { SettingsProps } from '../../../hooks/useGenericComponent'

export function GiftEditor(props: SettingsProps) {
  const { state } = props

  return (
    <div>
      <GiftSelector form={state} />
      <GiftQuantityInput form={state} />
    </div>
  )
}
